import { render, staticRenderFns } from "./TrashcanInfiniteRed.vue?vue&type=template&id=a992b0cc&"
import script from "./TrashcanInfiniteRed.vue?vue&type=script&lang=js&"
export * from "./TrashcanInfiniteRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports